import {
  MeetingTypeRef,
  AvailabilityChecks,
  ReserveTimeSlotRequestV3,
  ReservationUsers,
} from '@chilipiper/api-client/src/user-availability'
import { OptionMeetingTypeOverride } from '@chilipiper/api-client/src/team-scheduling'
import { MeetingLocations } from '@chilipiper/api-client/src/meeting-types'

export type MeetingTypeOverride = OptionMeetingTypeOverride & {
  duration?: string
  locations?: MeetingLocations
}

type ReserveTimeSlotProps = {
  users: ReservationUsers
  slotStartsAt: string
  meetingTypeOverride?: Partial<MeetingTypeOverride>
  meetingTypeRef: MeetingTypeRef
  availabilityChecks?: AvailabilityChecks
}

export const buildReserveTimeSlotPayload = ({
  users,
  slotStartsAt,
  meetingTypeOverride,
  meetingTypeRef,
  availabilityChecks,
}: ReserveTimeSlotProps): ReserveTimeSlotRequestV3 => {
  const meetingTypeOverrideProps = getReservationMeetingTypeOverride(meetingTypeOverride)

  return {
    meetingTypeRef,
    slotStartsAt,
    users,
    durationOverride: meetingTypeOverrideProps.durationOverride,
    afterBufferDurationOverride: meetingTypeOverrideProps.afterBufferDurationOverride,
    beforeBufferDurationOverride: meetingTypeOverrideProps.beforeBufferDurationOverride,
    availabilityChecks: availabilityChecks ?? {
      type: 'All',
    },
  }
}

const getReservationMeetingTypeOverride = (meetingTypeOverride?: Partial<MeetingTypeOverride>) => {
  return {
    durationOverride: meetingTypeOverride?.duration,
    afterBufferDurationOverride:
      meetingTypeOverride?.buffers?.after.type === 'Change'
        ? meetingTypeOverride?.buffers.after.value
        : undefined,
    beforeBufferDurationOverride:
      meetingTypeOverride?.buffers?.before.type === 'Change'
        ? meetingTypeOverride?.buffers.before.value
        : undefined,
  }
}
